/**
 * Adds a scrollbar to an element only when its content actually overflows.
 * Prevents phantom scrollbars caused by sub-pixel rounding at non-100% display scaling.
 *
 * Usage: SCM.Utilities.ScrollOverflow.observe(element);
 *
 * @param {HTMLElement} element - The element to observe for overflow
 */
var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

SCM.Utilities.ScrollOverflow = (function ($) {
    const ScrollThreshold = 2; // absorbs sub-pixel rounding at fractional DPI scaling
    const ScrollableClass = 'scroll-overflow--active';

    return {
        observe
    };

    function observe(element) {
        if (!element) {
            return;
        }

        toggleOverflow(element);

        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(function () {
                toggleOverflow(element);
            }).observe(element);
        }
    }

    function toggleOverflow(element) {
        const needsScroll = element.scrollHeight > element.clientHeight + ScrollThreshold;
        $(element).toggleClass(ScrollableClass, needsScroll);
    }
})(jQuery);
